<div class="la-tiere-dialog">
    <div mat-dialog-title class="la-tiere-dialog__header">
        <span>Tiere in Tierliste</span>
        <button
            *ngIf="canReload"
            type="button"
            mat-icon-button
            aria-label="Tiere neu laden"
            (click)="reloadTiere()"
            [disabled]="isReloading"
        >
            <mat-spinner *ngIf="isReloading" diameter="20"></mat-spinner>
            <mat-icon *ngIf="!isReloading">refresh</mat-icon>
        </button>
    </div>

    <div mat-dialog-content class="la-tiere-dialog__content">
        <mat-form-field appearance="outline" class="la-tiere-dialog__search">
            <mat-label>Ohrmarke suchen</mat-label>
            <input matInput [formControl]="tierSearchCtrl" autocomplete="off" />
            <button
                *ngIf="tierSearchCtrl.value"
                matSuffix
                mat-icon-button
                type="button"
                aria-label="Suche zurücksetzen"
                (click)="clearTierSearch()"
            >
                <mat-icon>close</mat-icon>
            </button>
            <mat-icon matPrefix>search</mat-icon>
        </mat-form-field>

        <p class="la-tiere-dialog__count">
            <ng-container *ngIf="tierSearchCtrl.value; else allTiereCount">
                {{ filteredTiereList.length }} von {{ tiere.length }} Tieren
            </ng-container>
            <ng-template #allTiereCount>{{ tiere.length }} Tiere</ng-template>
        </p>

        <ul *ngIf="filteredTiereList.length; else tiereEmpty" class="la-tiere-dialog__list">
            <li *ngFor="let tier of filteredTiereList" class="la-tiere-dialog__row">
                <div class="la-tiere-dialog__row-main">
                    <span class="la-tiere-dialog__ohrmarke">{{ tier.ohrmarke_notnull }}</span>
                    <span *ngIf="tier.abteil" class="la-tiere-dialog__abteil">Abteil {{ tier.abteil }}</span>
                </div>
                <div class="la-tiere-dialog__row-meta">
                    <span
                        class="la-tiere-dialog__einstalldatum"
                        [class.la-tiere-dialog__muted]="einstalldatumLabel(tier) === '—'"
                    >
                        {{ einstalldatumLabel(tier) }}
                    </span>
                    <span
                        class="la-tiere-dialog__haendler"
                        [class.la-tiere-dialog__muted]="haendlerLabel(tier) === '—'"
                    >
                        {{ haendlerLabel(tier) }}
                    </span>
                </div>
            </li>
        </ul>
        <ng-template #tiereEmpty>
            <p class="la-tiere-dialog__empty">
                {{
                    tierSearchCtrl.value
                        ? 'Keine Tiere passen zur Suche.'
                        : 'Keine Tiere in dieser Tierliste gefunden.'
                }}
            </p>
        </ng-template>
    </div>

    <div mat-dialog-actions align="end">
        <button type="button" mat-flat-button color="primary" (click)="close()">Schließen</button>
    </div>
</div>
